export default __webpack_public_path__ + "static/media/ic-org-type.c9336cbe.svg";